/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import Draggable, { DraggableCoreProps, DraggableEvent } from 'react-draggable'

import { SignPositionOffsetType } from '@schemas'
export type { DraggableEvent }

export interface DraggablePositionType {
	x: number
	y: number
	offsetY: number
	offsetX: number
}

interface PropsType {
	allowAnyClick?: DraggableCoreProps['allowAnyClick']
	cancel?: DraggableCoreProps['cancel']
	children?: DraggableCoreProps['children']
	disabled?: DraggableCoreProps['disabled']
	enableUserSelectHack?: DraggableCoreProps['enableUserSelectHack']
	offsetParent?: DraggableCoreProps['offsetParent']
	grid?: DraggableCoreProps['grid']
	handle?: DraggableCoreProps['handle']
	nodeRef?: DraggableCoreProps['nodeRef']
	onStart?: (e: DraggablePositionType) => void
	onDrag?: (e: DraggablePositionType) => void
	onStop?: (e: DraggablePositionType) => void
	onMouseDown?: DraggableCoreProps['onMouseDown']
	scale?: DraggableCoreProps['scale']
	bounds?: string
	positionOffset?: SignPositionOffsetType
}

export const DraggableView = (props: PropsType) => {
	const onStart = (e: any) => {
		if (props.onStart) {
			const res: DraggablePositionType = {
				x: e.x,
				y: e.y,
				offsetY: e.offsetY,
				offsetX: e.offsetX,
			}
			props.onStart(res)
		}
	}
	const onDrag = (e: any) => {
		if (props.onDrag) {
			const res: DraggablePositionType = {
				x: e.x,
				y: e.y,
				offsetY: e.offsetY,
				offsetX: e.offsetX,
			}
			props.onDrag(res)
		}
	}
	const onStop = (e: any) => {
		if (props.onStop) {
			const res: DraggablePositionType = {
				x: e.x,
				y: e.y,
				offsetY: e.offsetY,
				offsetX: e.offsetX,
			}
			props.onStop(res)
		}
	}
	return (
		<Draggable
			{...props}
			onStart={onStart}
			onDrag={onDrag}
			onStop={onStop}
			positionOffset={props.positionOffset}
		>
			{props.children}
		</Draggable>
	)
}
